import { useEffect } from "react";
import capitalizeFirstLetter from '/src/utils/capitalizeFirstLetter';
import storage from '/src/utils/storage';
function WrapperTitle({ route }) {

    const Component = route.component;

    useEffect(() => {

        if(route.path == '*' || route.path == '/') {
            document.title = 'Error'
            return
        }

        var company = storage('session').get('company');
        const paths = [...window.location.pathname.split("/")].filter(piece => piece);
        var mainPart = paths.length >= 3 ? paths[1] : paths[0];
        mainPart = capitalizeFirstLetter(mainPart)
        const lastPart = capitalizeFirstLetter(paths[paths.length - 1]);
        var title = mainPart == lastPart ? mainPart : `${mainPart} - ${lastPart}`;
        
        title = `${title} | ${"Anytech365"}`
        document.title = decodeURI(title);
      }, []);

    return <Component/>
}

export default WrapperTitle